<template>
  <RevTable
    v-if="addressRules.length"
    class="-mx-24"
    :collection="addressRules"
    :columns="formattedColumns"
    transparent-header
  >
    <template #body-address="{ item }">
      {{ item.address.label }}
    </template>

    <template #body-service="{ item }">
      {{ item.service.label }}
    </template>

    <template #body-categories="{ item }">
      {{ getCategoriesNames(item.categories) }}
    </template>

    <template #body-markets="{ item }">
      {{ getMarketsName(item.markets) }}
    </template>

    <template #body-action="{ item }">
      <RevContextualMenu class="z-10" position="bottom-end">
        <template #trigger="{ show }">
          <RevButtonIcon
            :alternative-text="i18n(translations.actions)"
            data-qa="profile-menu"
            :icon="IconMoreVertical"
            variant="secondary"
            @click="show"
          />
        </template>

        <template #items>
          <RevListItemInteractive @click="handleEditItem(item)">
            <template #label>{{ i18n(translations.edit) }}</template>
          </RevListItemInteractive>
          <RevListItemInteractive @click="handleDeleteItem(item)">
            <template #label>{{ i18n(translations.delete) }}</template>
          </RevListItemInteractive>
        </template>
      </RevContextualMenu>
    </template>
  </RevTable>
</template>

<script setup lang="ts">
import { type Country, merchantsAPI } from '@backmarket/http-api'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButtonIcon } from '@ds/components/ButtonIcon'
import { RevContextualMenu } from '@ds/components/ContextualMenu'
import { RevListItemInteractive } from '@ds/components/ListItemInteractive'
import { RevTable } from '@ds/components/Table'
import { IconMoreVertical } from '@ds/icons/IconMoreVertical'

import translations from './AddressRulesTable.translations'

const i18n = useI18n()

const formattedColumns = [
  { key: 'address', label: i18n(translations.address) },
  { key: 'service', label: i18n(translations.activities) },
  { key: 'categories', label: i18n(translations.categories) },
  { key: 'markets', label: i18n(translations.markets) },
  { key: 'action', label: '' },
]

const emit = defineEmits(['edit-item', 'delete-item'])

const { addressRules } = defineProps<{
  addressRules: merchantsAPI.AddressRule[]
}>()

function getCategoriesNames(
  categories: merchantsAPI.AddressRuleCategory[] | null,
) {
  return categories?.length
    ? categories.map(({ name }) => name).join(', ')
    : i18n(translations.allCategories)
}

function getMarketsName(markets: Country[] | null) {
  return markets?.length
    ? markets.map((countryCode: string) => i18n.country(countryCode)).join(', ')
    : i18n(translations.allMarkets)
}

function handleEditItem(item: merchantsAPI.AddressRule) {
  emit('edit-item', item)
}

function handleDeleteItem(item: merchantsAPI.AddressRule) {
  emit('delete-item', item)
}
</script>
